import { ActionInfoQuiet, Button, ScreenInfo } from '@krp/ui-kit'

import '../../../shared/platform.css'

import type { SourceAddActions, SourceAddVm } from '../model/types'
import { ActionReason } from './ActionReason'
import { QueryState } from '../../../shared/QueryState'

const SCREEN_INFO = {
  title: 'Что на этом экране',
  lines: [
    'Выберите, какой источник подключаем: виды, которые умеет эта установка, показаны плитками.',
    'После выбора откроется форма этого вида: название и настройки подключения.',
    'Пока вы не нажмёте «Создать» в форме, ничего не подключается и не записывается.',
  ],
} as const

/**
 * Первый шаг окна «Добавить источник»: плитки видов. Вид — крупная плитка со значком-меткой, названием и одной строкой
 * о том, что это; выбор плитки ведёт к форме этого вида (её даёт пакет вида). Экран получает vm и actions и больше
 * ничего. Недоступное добавление — слова с причиной, без плиток-муляжей.
 */
export function SourceAddScreen({ vm, actions }: { vm: SourceAddVm; actions: SourceAddActions }) {
  return (
    <ActionInfoQuiet>
      <section aria-labelledby="platform-source-add-title" className="platform-source-add">
        <header className="platform-source-add__head">
          <ScreenInfo title={SCREEN_INFO.title} lines={SCREEN_INFO.lines} />
          <h2 id="platform-source-add-title">Добавить источник</h2>
        </header>
        {vm.add.allowed ? (
          <>
            <p className="platform-source-add__lead">Что подключаем?</p>
            {/* Виды приходят с сервера (манифесты): пока список не пришёл или пуст, вместо плиток — его состояние. */}
            <QueryState query={vm.kindsQuery} emptyText="Сервер не объявил ни одного вида источников" onRetry={actions.reload} />
            {vm.kindsQuery.status === 'ready' && (
              <ul className="platform-source-add__kinds" aria-label="Виды источников">
                {vm.kinds.map((kind) => (
                  <li key={kind.kind} className="platform-source-add__tile">
                    <span className="platform-source-add__mark" aria-hidden="true">
                      {kind.mark}
                    </span>
                    <strong className="platform-source-add__title">{kind.title}</strong>
                    {kind.summary !== null && <span className="platform-source-add__summary">{kind.summary}</span>}
                    <Button
                      variant="primary"
                      disabled={!kind.pick.allowed}
                      onClick={() => actions.pick(kind.kind)}
                      aria-label={`Выбрать вид: ${kind.title}`}
                      actionId="platform.source-add.pick"
                      disabledReason={kind.pick.reason}
                    >
                      Выбрать
                    </Button>
                    <ActionReason action={kind.pick} />
                  </li>
                ))}
              </ul>
            )}
          </>
        ) : (
          <ActionReason action={vm.add} />
        )}
        <div className="platform-source-add__commands">
          <Button onClick={actions.cancel} actionId="platform.source-add.cancel">
            Отмена
          </Button>
        </div>
      </section>
    </ActionInfoQuiet>
  )
}
